import useBrowserStorage, { MessageDraft, MessageDraftDetail } from '$/components/BrowserStorage';
import EDate from '$/shared/frontend/utils/EDate';
import { LocalTimeZone } from '$/utils/LocalTimeZone';

export const useMessageStorage = (
  conversationId?: string
): {
  add: (messageValue: string) => void;
  remove: () => void;
  item: MessageDraftDetail | undefined;
  list: MessageDraft;
} => {
  const browserStorage = useBrowserStorage();
  const messagesContentFilterOut: MessageDraft = Object.keys(browserStorage.messagesContent)
    .filter(
      (key) =>
        new EDate(
          browserStorage.messagesContent[key]?.date ?? new Date(),
          LocalTimeZone.name
        ).getTime() > new EDate(new Date(), LocalTimeZone.name).subtractDays(7).getTime()
    )
    .reduce(
      (res: MessageDraft, key) => ((res[key] = browserStorage.messagesContent[key]), res),
      {}
    );
  // update message local storage
  const updateList = (content?: string): void => {
    if (!conversationId) return;
    browserStorage.messagesContent = {
      ...browserStorage.messagesContent,
      [conversationId]: content ? { date: new Date(Date.now()), content } : undefined,
    };
    browserStorage.save();
  };
  const item: MessageDraftDetail | undefined = conversationId
    ? messagesContentFilterOut[conversationId]
    : undefined;
  const add = (messageValue: string): void => {
    updateList(messageValue);
  };

  const remove = (): void => {
    updateList();
  };

  return {
    add,
    remove,
    item,
    list: messagesContentFilterOut,
  };
};
